<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">Hi, I'm Joe Radman.</h1>
        <!--
        <router-link :to="{ name: 'about', params: {}}">About</router-link>
        -->
        <p class="subheading font-weight-regular">
          I build websites. I build mobile apps. Mostly.
        </p>
        <v-row align="center" justify="center">
          <v-img
            src="/img/hero.jpg"
            lazy-src="/img/hero-sm.jpg"
            aspect-ratio="1"
            class="grey lighten-2"
            max-width="500"
            max-height="300"
          ></v-img>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    count() {
      return this.$store.state.destinations;
    },
  },
  created: function () {},
};
</script>
